import type { ReactNode } from "react";

interface SectionCardProps {
  title?: string;
  subtitle?: string;
  icon?: string;
  iconClass?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}

export default function SectionCard({
  title,
  subtitle,
  icon,
  iconClass = "bg-primary-100 text-primary-700",
  action,
  children,
  className = "",
  bodyClassName = "p-5",
}: SectionCardProps) {
  return (
    <section
      className={`yc-card-hover bg-white rounded-card border border-background-200 shadow-card ${className}`}
    >
      {(title || action) && (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between px-5 pt-5">
          <div className="flex items-center gap-2.5">
            {icon && (
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-full ${iconClass}`}
              >
                <i className={icon}></i>
              </span>
            )}
            <div>
              {title && (
                <h3 className="text-base font-bold text-foreground-950">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="mt-0.5 text-xs text-foreground-500">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {action}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </section>
  );
}